import { Result } from "..";

export abstract class OperationsService {
    public abstract downloadUsageReport(): void;
    public abstract resetReadModels(): void;
    public abstract tryMovePacket(academicId: string): void;
    public abstract executeCommand(caseId: string, cmd: Object): Promise<Result<null,string>>;
    public abstract downloadUserLoginReportExcel() : void;
}